import script from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AuthLayout.vue?vue&type=style&index=0&id=4ef15f58&lang=scss"

const __exports__ = script;

export default __exports__